ixModuleRouting("impactx.contentdashboard", {
    "/contentdashboard": {
        template: "<ixa-content-dashboard></ixa-content-dashboard>",
        templateUrl: "modules/contentdashboard/templates/contentdashboard.html",
        controller: "ContentDashboardCtrl as contentDashboardCtrl",
        workspace: "content",
    },
});
